import React from 'react';
import Modal from '../../../../components/Modal';
import { State as ReceiptState } from '../reducer';
import { Button, ButtonGroup } from '../../../../components/Buttons';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import ReceiptItems from './receiptItems';
import { InfoItemDd, InfoItemDt, InfoItemList, SectionHeader, SectionSubHeader } from '../../../common';
import { formatMoney } from '../../../../helpers/formatters';
import { DateTime } from '../../../../components/Formatters';
import Barcode from 'react-jsbarcode';

interface ReceiptProps extends WithTranslation {
    receipt: ReceiptState;
    clearReceipt: () => void;
}

const Receipt = (
    {
        receipt,
        clearReceipt,
        t,
        i18n,
    }: ReceiptProps
) => {
    if (receipt.isLoading || !receipt.receipt) return null;
    const lng = i18n.language;
    const receiptObj = receipt.receipt;
    return (
        <Modal>
            <SectionHeader>{t('customers.customer.receipt.fields.receipt')}</SectionHeader>
            <SectionSubHeader>ID: {receiptObj.id || 'N/A'}</SectionSubHeader>
            <ReceiptInfo>
                <InfoItemList className="vertical">
                    <InfoItemDt>{t('customers.customer.receipt.fields.receipt_id')}</InfoItemDt>
                    <InfoItemDd>
                        {receiptObj ? <Barcode value={receiptObj.receipt_id} options={{ height: 60 }} /> : 'N/A'}
                    </InfoItemDd>
                </InfoItemList>
                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.receipt.fields.store_name')}</InfoItemDt>
                    <InfoItemDd>
                        {receiptObj.store.name || receiptObj.store.business_name || 'N/A'}
                    </InfoItemDd>
                </InfoItemList>
                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.receipt.fields.store_id')}</InfoItemDt>
                    <InfoItemDd>
                        {receiptObj.store.id || 'N/A'}
                    </InfoItemDd>
                </InfoItemList>

                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.receipt.fields.purchase_date')}</InfoItemDt>
                    <InfoItemDd>
                        {receiptObj.purchase_at ? (
                            <DateTime isoString={receiptObj.purchase_at}/>
                        ) : (
                            'N/A'
                        )}
                    </InfoItemDd>
                </InfoItemList>
                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.receipt.fields.currency')}</InfoItemDt>
                    <InfoItemDd>{receiptObj.currency || 'N/A'}</InfoItemDd>
                </InfoItemList>
                <InfoItemList>
                    <InfoItemDt>{t('customers.customer.receipt.fields.total')}</InfoItemDt>
                    <InfoItemDd>
                        {receiptObj.net_amount && receiptObj.currency
                            ? formatMoney(lng, receiptObj.net_amount, receiptObj.currency)
                            : 'N/A'
                        }
                    </InfoItemDd>
                </InfoItemList>
            </ReceiptInfo>

            <ReceiptItems items={receiptObj.items} currency={receiptObj.currency}/>

            <br/>
            <br/>
            <ButtonGroup>
                <Button
                    onClick={() => clearReceipt()}
                >
                    {t('customers.customer.receipt.close')}
                </Button>
            </ButtonGroup>
        </Modal>
    );
};

const ReceiptInfo = styled.div`
    padding: 10px 0 30px 0;
`;

export default withTranslation()(Receipt);
